import { isInCapacitorPlatform } from '@fabric-app/compat/capabilities/platform';
import { Flex } from '@fabric-app/ui/components/Flex';
import { LinkExternal } from '@fabric-app/ui/components/Link/LinkExternal';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { preventForwardPropsConfig } from '@fabric-app/ui/utils/preventForwardProps';
import styled, { css } from 'styled-components';

type FooterTermsAndPolicyProps = {
  /**
   * If the footer will be absolutely positioned near the bottom of the screen
   */
  absolute?: boolean;

  /**
   * If it should show the home link
   */
  showHomeLink?: boolean;
};

const Wrapper = styled(Flex)
  .attrs<Pick<FooterTermsAndPolicyProps, 'absolute'>>({
    justifyContent: 'center',
    alignItems: 'center',
  })
  .withConfig(preventForwardPropsConfig(['absolute']))`
  height: 38px;
  padding: 0 1rem;
  padding-bottom: 20px;
  margin-top: auto;

  ${({ absolute }) =>
    absolute
      ? css`
          position: absolute;
          bottom: var(--safe-margin-offset-bottom, 0);
          align-self: center;
        `
      : ''}
`;

const LinkItem = styled(LinkExternal)`
  color: ${cssVar['color-text-placeholder']};
  font-size: 0.9375rem;
  ${mediaHover} {
    &:hover {
      color: ${cssVar['color-app-primary-text']};
    }
  }
`;
export const FooterTermsAndPolicy: React.FC<
  FooterTermsAndPolicyProps & React.ComponentPropsWithoutRef<typeof Wrapper>
> = ({ absolute, showHomeLink, ...props }) => {
  return (
    <Wrapper absolute={absolute} {...props}>
      <Flex gap="sections" alignItems="center">
        {showHomeLink && <LinkItem href="https://fabric.so">Home</LinkItem>}
        <LinkItem href="https://fabric.so/company/privacy">Privacy</LinkItem>
        <LinkItem href="https://fabric.so/company/tos">Terms</LinkItem>
        {isInCapacitorPlatform('capacitor-ios') && (
          <LinkItem href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/">
            EULA
          </LinkItem>
        )}
      </Flex>
    </Wrapper>
  );
};
